import { render } from "./OCases.vue?vue&type=template&id=22798c09&scoped=true"
import script from "./OCases.vue?vue&type=script&lang=js"
export * from "./OCases.vue?vue&type=script&lang=js"

import "./OCases.vue?vue&type=style&index=0&id=22798c09&scoped=true&lang=css"

import exportComponent from "D:\\JOSE\\Escritorio\\Proyectos VUE\\canal-denuncias\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22798c09"]])

export default __exports__